const ChainList = {
  1: { name: "Ethereum", currency: "ETH", decimals: 18, nftMarketUrl: "https://opensea.io/ja/assets/ethereum" },
  137: { name: "Polygon", currency: "MATIC", decimals: 18, nftMarketUrl: "https://opensea.io/ja/assets/matic" },
  592: { name: "Astar", currency: "ASTR", decimals: 18, nftMarketUrl: "https://tofunft.com/ja/nft/astar" },
};

export default ChainList;
